import type { Content } from 'pdfmake/interfaces';

/**
 * Genera el footer para los documentos PDF
 * Mantiene el estilo y diseño consistente con los otros componentes
 */
export function getDocumentFooter() {
  return (currentPage: number, pageCount: number) : Content =>
  ({
      columns: [
        {
          width: '50%',
          stack:[
            {
              text: 'Página ' + currentPage.toString() + ' de ' + pageCount,
              style: 'footerPageLeft'
            }
          ]
        },
        {
          width: '50%',
          stack: [
            {
              text: 'Analuu Tools (HIS) - Sistema de información hospitalaria desarrollado por JA Software SAS',
              style: 'footerPageRicht'
            },
            {
              text: [
                { text: 'Para contactos acerca del software visita ' },
                { text: 'www.jasoftwaresas.com', link: 'https://www.jasoftwaresas.com', color: 'blue' }
              ],
              style: 'footerPageRicht'
            }
          ]
        }
      ],
      margin: [40, 5, 40, 0]
    })
  }

				
